module.exports = __webpack_public_path__ + "static/media/test14_4.b5f4f9cc.png";